import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      appName: 'iAdvocate',
      login: 'Login',
      email: 'Email',
      password: 'Password',
      start: 'Start',
      submit: 'Submit',
      dashboard: 'Dashboard',
      cases: 'Cases',
      clients: 'Clients',
      hearings: 'Hearings',
      payments: 'Payments',
      documents: 'Documents',
      chooseLanguage: 'Choose your language',
      english: 'English',
      hindi: 'Hindi',
      next: 'Next',
      profileSetup: 'Profile Setup',
      myProfile: 'My profile',
      name: 'Name',
      phone: 'Phone',
      address: 'Address',
      officeAddress: 'Office / chamber address',
      enrollmentNumber: 'Enrollment number',
      profilePic: 'Profile Picture',
      uploadPhoto: 'Upload photo',
      changePhoto: 'Change photo',
      save: 'Save',
      inviteAdvocates: 'Invite Advocates',
      generateLink: 'Generate Invite Link',
      home: 'Home',
      secureAccess: 'Secure access',
      roleBasedAccess: 'Role-based access',
      firstTimeSetup: 'First-time setup',
      createAccount: 'Create your account',
      createOne: 'Create one',
      signIn: 'Sign in',
      continueWithGoogle: 'Continue with Google',
      needTestAccount: 'Need a test account?',
      needAccount: 'Need an account?',
      alreadyHaveAccount: 'Already have an account?',
      selectLanguage: 'Language',
      closeNavigation: 'Close navigation',
      continueLabel: 'Continue',
      installAppEyebrow: 'Welcome',
      installAppTitle: 'Opening your workspace',
      installAppSubtitle: 'One moment while iAdvocate prepares your legal workspace.',
      installPromptReadyTitle: 'Add iAdvocate to your phone',
      installPromptReadyBody: 'Your browser is ready to add iAdvocate now. Confirm once and it will open from your home screen next time.',
      installPromptReadyStep: 'Tap the button below and confirm when your device asks.',
      installPromptButton: 'Add iAdvocate',
      installLater: 'Not now',
      installContinueBrowser: 'Continue in browser',
      installMobileNudgeTitle: 'Use iAdvocate like an app',
      installMobileNudgeBody: 'For the best mobile experience, add iAdvocate to your home screen. It opens faster and feels cleaner for daily case work.',
      installManualHint: '',
      installSharePrompt: 'Use the share menu to add iAdvocate to your home screen.',
      installAndroidChromeTitle: 'Open this in Chrome on Android',
      installAndroidChromeBody: 'This browser is not exposing the add-to-home-screen prompt.',
      installAndroidChromeStepOne: 'Copy this link.',
      installAndroidChromeStepTwo: 'Open it in Chrome on your Android phone and continue there.',
      installAndroidManualTitle: 'Use Chrome menu',
      installAndroidManualBody: 'Chrome did not expose the prompt this time, but you can still add iAdvocate quickly.',
      installAndroidManualStepOne: 'Open the three-dot menu in Chrome.',
      installAndroidManualStepTwo: 'Choose Add to Home screen or Install app.',
      installIosSafariTitle: 'Open this in Safari',
      installIosSafariBody: 'iPhone and iPad only support home-screen install from Safari.',
      installIosSafariStepOne: 'Copy this link.',
      installIosSafariStepTwo: 'Open it in Safari, then continue from there.',
      installIosShareTitle: 'Use the Share menu',
      installIosShareBody: 'Safari can add iAdvocate to your home screen from the Share sheet.',
      installIosShareStepOne: 'Open the Share menu.',
      installIosShareStepTwo: 'Choose Add to Home Screen.',
      installIosShareButton: 'Open Share menu',
      installDesktopTitle: 'Add it from your browser menu',
      installDesktopBody: 'Chrome or Edge on desktop can save iAdvocate like an app.',
      installDesktopStepOne: 'Open the browser menu or the install icon in the address bar.',
      installDesktopStepTwo: 'Choose Install iAdvocate or Create shortcut.',
      installDesktopBrowserTitle: 'Use Chrome or Edge',
      installDesktopBrowserBody: 'This browser does not expose app install controls for iAdvocate.',
      installDesktopBrowserStepOne: 'Copy this link.',
      installDesktopBrowserStepTwo: 'Open it in Chrome or Edge and continue there.',
      copyLinkButton: 'Copy link',
      installLinkCopied: 'Link copied',
      openInstalledAppTitle: 'Open the installed app to continue',
      openInstalledAppSubtitle: 'This browser is now only for reaching the installed app.',
      openInstalledAppBody: 'iAdvocate is already installed on this device. Continue from the home-screen app instead of the browser.',
      openInstalledAppStepOne: 'Close this browser tab.',
      openInstalledAppStepTwo: 'Open iAdvocate from your home screen or app launcher.',
      openInstalledAppButton: 'Check again',
      continueInBrowser: 'Continue in browser',
      updateAvailableEyebrow: 'Update ready',
      updateAvailableTitle: 'Version {{version}} is ready',
      updateAvailableBody: 'Refresh now to load version {{version}} with the latest fixes and changes.',
      updateNow: 'Refresh now',
      later: 'Later',
      languageSubtitle: 'A simple legal workspace for advocates, case updates, client links, and payments.',
      loginSubtitle: 'Sign in and continue to your advocate or admin workspace.',
      signupSubtitle: 'Create an advocate or admin account. Clients continue through secure case links only.',
      profileSubtitle: 'Complete your profile so your legal workspace is ready to use on mobile, tablet, and desktop.',
      role: 'Role',
      confirmPassword: 'Confirm Password',
      createAccountButton: 'Create account',
      logout: 'Logout',
      recorded: 'Recorded',
      tentative: 'Tentative',
      dateToBeUpdated: 'date to be updated',
      timelineReached: 'timeline reached',
      practiceDashboard: 'Practice dashboard',
      practiceDashboardSubtitle: 'Quick view of matters, clients, hearings, and payments.',
      todayAtAGlance: 'Today at a glance',
      dashboardHeroTitle: 'Pick up where work is waiting.',
      dashboardHeroSubtitle:
        'Open a matter or client and continue from the next practical step.',
      activeMatters: 'Active matters',
      immediateFocus: 'Immediate focus',
      reminders: 'Reminders',
      noUrgentReminders: 'Nothing urgent right now.',
      nextSevenDays: 'Next seven days',
      upcomingHearings: 'Upcoming hearings',
      noHearingsWeek: 'No hearings scheduled in the coming week.',
      trackStatusClientMapping: 'Open matters and continue the next step.',
      keepContactsAccessible: 'Keep contacts and linked matters easy to reach.',
      clientLinks: 'Client links',
      shareSecureClientLinks: 'Share secure case access links directly with clients.',
      dashboardDraftingCardSubtitle: 'Prepare first drafts from case context, notes, and uploaded records.',
      clientsSubtitle: 'Keep key contact details reachable in a few taps.',
      clientIntake: 'Client intake',
      addClient: 'Add a client',
      openAddClientForm: 'Open add client form',
      closeAddClientForm: 'Close add client form',
      addClientHint: 'Open the client form when you want to add a new client profile.',
      clientFullName: 'Client full name',
      mobileNumber: '10-digit mobile number',
      optionalEmail: 'Optional email address',
      directory: 'Directory',
      clientsEmpty: 'Your client list is empty. Add one to begin organizing your practice.',
      noEmailAdded: 'No email added',
      hearingsSubtitle: 'See upcoming court dates clearly and update them without scrolling around.',
      schedule: 'Schedule',
      addHearing: 'Add a hearing',
      caseId: 'Case ID',
      linkedCaseNumber: 'Linked case number',
      date: 'Date',
      description: 'Description',
      purposeOfHearing: 'Purpose of hearing',
      calendar: 'Calendar',
      hearingsEmpty: 'No hearings added yet. Start with the next listed matter.',
      noDescriptionAdded: 'No description added',
      paymentsSubtitle: 'Record fees fast and keep collection history visible during client follow-ups.',
      feeEntry: 'Fee entry',
      addPayment: 'Add a payment',
      amount: 'Amount',
      amountInInr: 'Amount in INR',
      paymentPurpose: 'What was the payment for?',
      clientAction: 'Client action',
      requestClientPayment: 'Request client payment',
      recordReceivedPayment: 'Record received payment',
      collections: 'Collections',
      entries: 'entries',
      paymentsEmpty: 'No payments recorded yet. Add the latest received amount to start tracking.',
      paid: 'Paid',
      documentsSubtitle: 'Upload matter files with large touch targets and quick access links.',
      documentsUploadGuard: 'Add a case ID and document type before uploading.',
      uploadPrep: 'Upload prep',
      documentDetails: 'Document details',
      type: 'Type',
      documentTypePlaceholder: 'Affidavit, Notice, Vakalatnama...',
      documentsDropzoneTitle: 'Tap to upload or drag files here',
      documentsDropzoneSubtitle: 'PDFs, images, and notes can be attached to the selected matter.',
      library: 'Library',
      files: 'files',
      documentsEmpty: 'No documents uploaded yet. Add a case ID, choose a type, and upload a file.',
      generalFile: 'General file',
      forLabel: 'for',
      unassignedCase: 'unassigned case',
      open: 'Open',
      adminDashboard: 'Admin dashboard',
      adminDashboardSubtitle: 'A lightweight IT admin view for account health, role distribution, and platform checks.',
      admins: 'Admins',
      advocates: 'Advocates',
      operations: 'Operations',
      systemAlerts: 'System alerts',
      platformSnapshot: 'Platform snapshot',
      itAdminControls: 'IT admin controls',
      authentication: 'Authentication',
      authenticationSummary: 'Email/password and Google sign-in are enabled in the app flow for testing.',
      active: 'Active',
      paymentsTracked: 'Payments tracked',
      paymentsTrackedSummary: '{{count}} payment records are available across advocate and client views.',
      adminDataIsolationSummary: 'Admin access is limited to admin-owned alerts and operational checks. Advocate-client matter data is intentionally isolated.',
      live: 'Live',
      clientAccessLinks: 'Client access links',
      clientAccessLinksSubtitle:
        'Share a client-safe case view over WhatsApp, SMS, or email. The link remains active until the case is concluded or you disable it.',
      shareableCaseAccess: 'Shareable case access',
      links: 'links',
      clientLinksEmpty: 'No cases available yet. Add a case first, then return here to share its client link.',
      shareOnWhatsApp: 'Share on WhatsApp',
      shareBySms: 'Share by SMS',
      previewClientCaseView: 'Preview client case view',
      preferredLanguage: 'Preferred language',
      relationLabel: 'Relation label',
      relationName: 'Relation name',
      age: 'Age',
      dateOfBirth: 'Date of birth',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      aadhaarName: 'Aadhaar-aligned name',
      aadhaarNumber: 'Aadhaar number',
      aadhaarReference: 'Aadhaar reference document',
      aadhaarUploadPreferred: 'Upload Aadhaar first (preferred)',
      aadhaarReading: 'Reading Aadhaar details with OCR.',
      aadhaarReadSuccess: 'Aadhaar details were read. Review and correct anything that looks off.',
      aadhaarNeedsReview: 'Aadhaar needs review',
      aadhaarOcrPreview: 'Aadhaar OCR preview',
      aadhaarReadFailed: 'Aadhaar could not be read clearly. You can enter the details manually.',
      aadhaarIntakeChoiceTitle: 'Choose how you want to add client details',
      aadhaarIntakeChoiceSubtitle: 'Start with Aadhaar OCR for faster intake, or switch to manual entry when needed.',
      useAadhaarFlow: 'Use Aadhaar OCR',
      useManualFlow: 'Fill manually',
      aadhaarFlowHint: 'Upload the Aadhaar image or PDF. The form will open after OCR fills the details.',
      manualFlowHint: 'Open the full client profile form and enter the details yourself.',
      reviewClientDetails: 'Review client details',
      aadhaarProcessingTitle: 'Reading Aadhaar details',
      aadhaarProcessingBody: 'OCR and AI mapping are preparing the client form for review.',
      draftingProcessingTitle: 'Preparing your draft',
      draftingProcessingBody: 'Please wait while iAdvocate reads the sources and prepares the next step.',
      draftReady: 'Draft-ready',
      draftProfileIncomplete: 'Profile incomplete',
      clientDraftProfile: 'Drafting profile',
      legalIdentity: 'Legal identity',
      editClientProfile: 'Edit client profile',
      closeEditClientProfile: 'Close client profile editor',
      draftReadyClients: 'draft-ready clients',
      clientProfilesForDrafting: 'Structured profiles improve AI drafting quality.',
      selectClientBeforeDrafting: 'Select a client before starting drafting.',
      selectClient: 'Select client',
      clientProfileIncompleteForDrafting: 'Complete the client profile before drafting.',
      openClientProfile: 'Open client profile',
      addClientAndContinue: 'Add client and continue',
      clientAddedForDrafting: 'Client created and linked for drafting.',
      draftingInstructionsRequired: 'Add advocate instructions before generating the draft.',
      validateDraftFacts: 'Validate draft facts',
      validateKeyFacts: 'Validate key facts',
      factValidationHint: 'Review the risky factual details below before opening the final draft editor.',
      draftingNoValidationFieldsTitle: 'No structured fact edits are required right now.',
      draftingNoValidationFieldsBody: 'The draft was flagged for validation, but no editable fact fields were returned. You can continue directly to the full draft review.',
      applyFactsAndContinue: 'Apply facts and continue',
      skipToDraftReview: 'Skip to draft review',
      aiDraftingLeanSubtitle: 'Start a draft with one client, optional source files, and your instructions.',
      resumeWorkflow: 'Resume draft',
      startWorkflow: 'New draft',
      singleFlowDrafting: 'Start a new draft',
      draftingContextSubtitle: 'Choose the client first. Add source files only when they help.',
      readyToStart: 'Ready to start',
      reviewAiContext: 'Review AI context',
      reviewBeforeAiDrafting: 'Review what will be sent to AI',
      draftingPromptSummary: 'Context summary',
      promptPreview: 'Prompt preview',
      noSourceFilesAdded: 'No source files were added',
      ocrFailedForSource: 'OCR could not read this source clearly',
      ocrReadSuccess: 'OCR text is ready for review',
      textReadSuccess: 'Source text is ready for review',
      manualContextFallbackPlaceholder: 'OCR could not read this file. Add the important facts manually before sending to AI.',
      ocrFailureManualFallbackHint: 'One or more files could not be read clearly. Add manual context if needed, then continue to AI.',
      sendToAiGenerateDraft: 'Send to AI and generate draft',
      draftingPreparingPrompt: 'Preparing the reviewed context for AI.',
      draftingPromptReviewReady: 'Review the OCR result and prompt context before sending it to AI.',
      savedWorkflows: 'Saved drafts',
      resumeOrDiscard: 'Resume or discard',
      stepOne: 'Step 1',
      chooseClientAndCase: 'Choose client and matter',
      stepTwo: 'Step 2',
      uploadSourceDocumentsOptional: 'Upload source documents (optional)',
      optionalSourceUploadHint: 'Add FIR copies, complaints, notices, replies, or leave this empty and draft from the case and client context.',
      stepThree: 'Step 3',
      advocateInstructions: 'Advocate instructions',
      draftPreview: 'Draft preview',
      openFullScreenReview: 'Open full-screen review',
      place: 'Place',
      policeStation: 'Police station',
      casesSubtitle: 'Create and manage matters, next steps, lifecycle stages, and client sharing.',
      newMatter: 'Create',
      addCase: 'New matter',
      closeAddCaseForm: 'Close add case form',
      openAddCaseForm: 'Open add case form',
      caseNumber: 'Case Number',
      clientName: 'Client Name',
      clientEmail: 'Client Email',
      clientPhone: 'Client Phone',
      caseSummary: 'Case Summary',
      nextStep: 'Next Step',
      statusLabel: 'Status',
      stepPreset: 'Step preset',
      tentativeMonth: 'Tentative month',
      lifecyclePlanning: 'Lifecycle',
      stepTitle: 'Step title',
      addLifecycleStep: 'Add lifecycle step',
      closeAddStageForm: 'Close lifecycle stage form',
      addCaseButton: 'Add Case',
      addMatterHint: 'Open this form when you want to add a new matter.',
      currentMatters: 'Matter list',
      caseBoard: 'matters',
      noCasesYet: 'No cases yet. Add your first matter to start tracking progress.',
      noNextStepYet: 'No next step added yet.',
      noLifecyclePlanned: 'No stages added yet',
      milestonesComplete: 'stages complete',
      clientLinkLive: 'Client link live',
      clientLinkPaused: 'Client link paused',
      openCaseDetails: 'Open case details',
      caseDetails: 'Case details',
      loadingMatterDetails: 'Loading matter details.',
      caseNotFound: 'This case could not be found.',
      caseDetailsSubtitle: 'Matter details, client access, lifecycle tracking, and case-linked payments in one place.',
      clientLabel: 'Client',
      clientContactMissing: 'Client contact not added yet.',
      matterBrief: 'Matter brief',
      summaryLabel: 'Summary',
      noSummaryAdded: 'No summary added yet.',
      nextStepShort: 'Next step',
      clientLinkLabel: 'Client link',
      clientLinkActive: 'Active until case closure or manual pause.',
      clientLinkDisabled: 'Currently disabled.',
      lifecycle: 'Lifecycle',
      progressControl: 'Progress control',
      lifecycleFormHint: 'Add stages only when needed. Otherwise the case starts with an initial consultation stage.',
      pauseClientAccess: 'Pause client access',
      enableClientAccess: 'Enable client access',
      stepNumber: 'Step {{count}}',
      inProgress: 'In progress',
      done: 'Done',
      requestOrRecordFees: 'Request or record fees',
      closePaymentForm: 'Close payment form',
      openPaymentForm: 'Open payment form',
      stage: 'Stage',
      paymentMode: 'Payment mode',
      requestFromClient: 'Request from client',
      recordReceived: 'Record received payment',
      requestPayment: 'Request payment',
      savePayment: 'Save payment',
      feeFormHint: 'Open the fee form when you need to request a payment or record a received amount.',
      openPaymentHistory: 'Open payment history',
      closePaymentHistory: 'Close payment history',
      caseFee: 'Case fee',
      clientCaseAccess: 'Client case access',
      clientCaseAccessSubtitle:
        'Shared by your advocate for reviewing progress, payments, documents, and updates relevant to your matter.',
      loadingCaseAccess: 'Loading case access',
      openingClientView: 'Opening the client view for this case link.',
      linkNotFound: 'Link not found',
      invalidClientLink: 'This client access link is invalid or no longer exists.',
      caseAccessClosed: 'Case access closed',
      caseAccessClosedSubtitle:
        'This link is no longer active because the case has been concluded or client access was disabled.',
      importantDetails: 'Important details',
      court: 'Court',
      notAdded: 'Not added',
      nextStepSoon: 'Your advocate will update the next step shortly.',
      progressTracker: 'Progress tracker',
      caseLifecycle: 'Case lifecycle',
      completedRecordedByAdvocate: 'Completed and recorded by your advocate.',
      currentlyActiveInCase: 'Currently active in your case.',
      upcomingCaseJourney: 'Upcoming in the case journey.',
      fees: 'Fees',
      requestedSubmittedPayments: 'Requested and submitted payments',
      amountPaid: 'Amount paid',
      paymentNote: 'Payment note',
      paymentNotePlaceholder: 'Reference, UPI note, or stage',
      submitPaymentUpdate: 'Submit payment update',
      sharedFilesUploads: 'Shared files and uploads',
      shared: 'shared',
      tapToUploadCaseDoc: 'Tap to upload a document or image for this case',
      clientUploadHint: 'Your advocate will be able to review this upload inside the case records.',
      comments: 'Comments',
      caseNotes: 'Case notes',
      caseNotesEmpty: 'No case notes yet. Client messages and advocate notes will appear here.',
      caseNotesHint: 'Open notes history or add a new note only when needed.',
      openCaseNotesForm: 'Open case notes form',
      closeCaseNotesForm: 'Close case notes form',
      openCaseNotesHistory: 'Open case notes history',
      closeCaseNotesHistory: 'Close case notes history',
      addCaseNote: 'Add case note',
      addCaseNotePlaceholder: 'Add an internal note or a reply for the client.',
      saveCaseNote: 'Save case note',
      caseDocuments: 'Case documents',
      caseDocumentsEmpty: 'No case documents available for this matter yet.',
      caseDocumentsHint: 'Published drafts and advocate-uploaded case files will appear here.',
      expandCaseDocuments: 'Expand case documents',
      collapseCaseDocuments: 'Collapse case documents',
      editInDrafting: 'Edit in drafting',
      clientSharedDocuments: 'Client shared documents',
      clientDocumentsEmpty: 'No client documents shared yet for this matter.',
      clientDocumentsHint: 'Open this section to review files uploaded by the client.',
      expandClientDocuments: 'Expand client shared documents',
      collapseClientDocuments: 'Collapse client shared documents',
      updatesQuestions: 'Updates and questions',
      addMessageForAdvocate: 'Add a message for your advocate',
      sendMessage: 'Send message',
      previewModeNotice: 'Preview mode is on. Client actions are visible here but disabled for advocate review.',
      previewModeUploadHint: 'Uploads are disabled in preview mode.',
      preferredLocale: 'en-IN',
      about: 'About',
      aboutSubtitle: 'A quick guide for advocates on what iAdvocate supports and how to get started well.',
      aboutOnboardingTitle: 'Set up your practice once, then work case by case',
      aboutOnboardingBody:
        'iAdvocate is built for advocates who want one mobile-first workspace for client intake, matter tracking, secure client updates, payments, documents, and AI-assisted drafting without juggling multiple tools.',
      aboutFeatureDashboardsTitle: 'Dashboard and daily control',
      aboutFeatureDashboardsBody:
        'Use drill-in cards for active matters, clients, upcoming hearing stages, payments, premium drafting access, and invite flows from one dashboard.',
      aboutFeatureClientsTitle: 'Client intake and drafting-ready profiles',
      aboutFeatureClientsBody:
        'Add clients manually or start with Aadhaar OCR, then maintain drafting-ready identity details, preferred language, contact info, and private reference records in one place.',
      aboutFeatureCasesTitle: 'Case-led workflow',
      aboutFeatureCasesBody:
        'Create matters for existing clients, manage summaries, next steps, manual lifecycle stages, hearing dates, notes, and fee history from the case details screen.',
      aboutFeatureClientAccessTitle: 'Secure client case sharing',
      aboutFeatureClientAccessBody:
        'Share one secure case link from case details so clients can view relevant updates, lifecycle progress, payments, comments, and shared documents without creating a login.',
      aboutFeatureDraftingTitle: 'AI Legal Drafting Assistant',
      aboutFeatureDraftingBody:
        'Generate advocate-private first drafts from structured advocate and client profiles, case context, typed instructions, uploaded source files, OCR-reviewed text, and full-screen draft review.',
      aboutFeatureBillingTitle: 'Core, trial, and AI Plus credits',
      aboutFeatureBillingBody:
        'Use the free Core plan for non-AI work, activate a one-time AI Trial for limited credits, or subscribe to AI Plus for monthly bundled credits and wallet top-ups for heavier OCR and drafting usage.',
      aboutFeatureDocumentsTitle: 'Documents, OCR, and publishing',
      aboutFeatureDocumentsBody:
        'Upload case files, read text from PDFs and images, publish approved AI drafts into case documents, and keep client-shared uploads visible in the right matter only.',
      aboutFeaturePaymentsTitle: 'Payments and case notes',
      aboutFeaturePaymentsBody:
        'Track fee requests and receipts inside each matter, maintain dated case notes, and keep client updates visible to the advocate in case context.',
      aboutFeatureSecurityTitle: 'Data isolation and privacy',
      aboutFeatureSecurityBody:
        'Advocate-owned data stays isolated by advocate account, client access is token-scoped per case, and admin access does not expose advocate-client business records.',
      aboutGettingStartedEyebrow: 'Getting started',
      aboutGettingStartedTitle: 'A good first setup for a new advocate',
      aboutStepOneTitle: '1. Complete your profile',
      aboutStepOneBody:
        'Add your advocate name, enrollment number, office details, language preference, and optional photo so drafting and client-facing records start with the right identity.',
      aboutStepTwoTitle: '2. Add clients properly',
      aboutStepTwoBody:
        'Create clients with full legal identity details. Aadhaar-first intake is supported, and cleaner client profiles make AI drafting and case communication much better.',
      aboutStepThreeTitle: '3. Open matters from the case view',
      aboutStepThreeBody:
        'Create a case only after selecting an existing client, then add summary, next step, lifecycle stages, hearing dates, payments, notes, and documents in one place.',
      aboutStepFourTitle: '4. Share and draft when ready',
      aboutStepFourBody:
        'Share client access only from case details, and use AI Legal Drafting when client and advocate profiles are ready so the first draft needs less manual cleanup.',
      aboutWhatItIs: 'What iAdvocate is',
      aboutDescription:
        'iAdvocate is a legal-practice workspace for advocates to manage matters, clients, hearings, documents, payment requests, and secure client case links from one mobile-first app.',
      forAdvocates: 'For advocates',
      aboutAdvocateSuiteTitle: 'What advocates can do in iAdvocate',
      aboutAdvocateDashboard: 'Use a mobile-first dashboard with drill-in cards for active matters, clients, hearing timelines, payments, and drafting access.',
      aboutAdvocateCases: 'Run each matter through one case-led workflow with lifecycle stages, dated hearings, fee requests, client sharing, and detailed matter notes.',
      aboutAdvocateDrafting: 'Generate advocate-private AI first drafts from uploaded files, OCR-reviewed text, typed notes, and case context before publishing to case documents.',
      aboutAdvocateClientLinks: 'Share a secure client view over WhatsApp or SMS so clients can track progress, see due fees, upload documents, and send updates.',
      features: 'Features',
      aboutSupports: 'What the app supports',
      aboutRecentCapabilitiesTitle: 'Recent product capabilities',
      aboutCases: 'Create matters, plan lifecycle milestones, and track progress with client-safe views.',
      aboutClientLinks: 'Share secure case links with clients over WhatsApp or SMS without requiring a separate login.',
      aboutPayments: 'Request fees, record receipts, and let clients submit payment updates in case context.',
      aboutDocuments: 'Upload advocate and client documents tied to a matter with shared visibility where relevant.',
      aboutHearings: 'Track hearings as lifecycle stages with dates, purpose, notes, and dashboard-ready upcoming hearing visibility.',
      languageSupport: 'Language support',
      aboutLanguageSupport: 'Remember advocate and client language preference so the workspace and shared client link open in the right language.',
      privacyPolicy: 'Privacy policy',
      privacyTitle: 'Privacy and data handling',
      privacyBody:
        'iAdvocate stores case, client, document, and payment information so advocates can manage legal matters and share relevant updates with clients. Client links should only be shared with the intended recipient. Sensitive legal data should be entered and shared only where appropriate for the matter.',
      consent: 'Consent',
      consentTitle: 'Consent and client communication',
      consentBody:
        'By using iAdvocate, advocates are responsible for obtaining the client consent needed to store records, share case updates, request payments, and exchange documents through the app. Clients using a shared case link consent to viewing case information relevant to them and to submitting documents, comments, or payment updates through that link.',
      supportEmailLabel: 'Support:',
      premiumTitle: 'Premium plan',
      premiumSubtitle: 'Unlock AI Legal Drafting with a simple monthly subscription for your advocate workspace.',
      premiumActiveSubtitle: 'Your premium access is already active on this account.',
      premiumPlanLabel: 'Premium access',
      premiumAlreadyActiveTitle: 'Premium is already active',
      premiumAlreadyActiveBody: 'This advocate account already has premium access, so you can continue directly to AI Legal Drafting.',
      premiumLockedFeatureTitle: 'AI Legal Drafting is a premium feature',
      premiumLockedFeatureBody: 'Upgrade to the monthly premium plan to generate AI-assisted legal drafts, review OCR text, and export drafting output.',
      premiumMonthlyPlan: 'Monthly premium plan',
      premiumPlanHeadline: 'Unlock premium for Rs {{amount}} per month',
      premiumFeatureDrafting: 'Generate first drafts for notices, affidavits, bail applications, replies, agreements, and other reusable legal formats.',
      premiumFeatureOcr: 'Review text extracted from uploaded PDFs and scanned legal records before generation.',
      premiumFeatureExports: 'Save, edit, export DOCX, and publish approved drafts into case documents.',
      premiumShort: 'Premium',
      aiLockedShort: 'Premium',
      aiAccessTitle: 'Premium access and credits',
      aiAccessSubtitle: 'Manage trial credits, monthly bundled credits, and wallet top-ups for premium drafting and OCR features.',
      aiAccessEyebrow: 'Premium plans',
      aiAccessForFeature: 'Premium access for {{feature}}',
      aiAccessReadyBody: 'You already have usable credits on this advocate account. Continue to the feature or top up if you expect heavier OCR or drafting usage.',
      aiAccessTopupBody: 'Your premium plan is active, but your included credits may be exhausted. Add wallet credits to keep premium drafting and OCR available.',
      aiAccessLockedBody: 'Drafting and OCR are premium capabilities. Start the free trial or subscribe to AI Plus when you want to use them.',
      aiAccessUpdated: 'Premium access settings were updated.',
      manageAiAccess: 'Manage premium access',
      premiumAccessEyebrow: 'Premium access',
      managePremiumAccess: 'Manage premium access',
      corePlan: 'Core',
      trialPlan: 'Trial',
      noAiCreditsLeft: 'No credits left',
      notAvailableShort: 'Not available',
      renewalOn: 'Renewal on',
      renewalOff: 'Renewal off',
      subscriptionCycle: 'Subscription cycle',
      subscriptionCycleDates: '{{start}} to {{end}}',
      noSubscriptionCycle: 'No active subscription cycle yet.',
      trialEndsOn: 'Trial valid until {{date}}',
      resumeSubscription: 'Resume subscription',
      thisMonthUsage: 'This month usage',
      aiUsageBreakdown: 'Input {{input}} tokens, output {{output}} tokens, OCR {{ocr}} pages/images, {{credits}} credits consumed.',
      creditBalances: 'Credit balances',
      creditBalanceBreakdown: 'Trial {{trial}}, included {{included}}, wallet {{wallet}} credits remaining.',
      startFreeTrial: 'Start free trial',
      subscribeAiPlus: 'Subscribe to AI Plus for Rs {{amount}} / month with {{credits}} credits',
      turnOffRenewal: 'Turn off renewal',
      continueToAiFeature: 'Continue to AI feature',
      walletCreditsTitle: 'Wallet credits',
      topUpWallet: 'Top up wallet',
      topUpPackLabel: 'Rs {{amount}} top-up',
      topUpPackCredits: '{{credits}} wallet credits',
      buyCredits: 'Buy credits',
      billingHistoryEyebrow: 'Billing activity',
      billingHistoryTitle: 'Billing history',
      billingHistoryEmpty: 'No billing activity has been recorded yet.',
      billingHistoryMeta: 'Rs {{amount}}, {{credits}} credits',
      recordedShort: 'Recorded',
      recentAiUsage: 'Recent premium usage',
      usageHistory: 'Usage history',
      usageHistoryEmpty: 'No AI usage has been recorded yet.',
      generalUsage: 'General premium usage',
      creditsUsedBadge: '{{credits}} credits used',
      subscription_started: 'Subscription started',
      subscription_checkout_started: 'Subscription checkout started',
      subscription_cancelled: 'Renewal turned off',
      subscription_renewed: 'Subscription renewed',
      wallet_topup_checkout_started: 'Top-up checkout started',
      wallet_topup: 'Wallet topped up',
      trial_activated: 'Trial started',
      razorpay_subscription_activated: 'Subscription activated',
      razorpay_subscription_charged: 'Subscription charged',
      razorpay_subscription_cancelled: 'Subscription cancelled',
      drafting: 'AI drafting',
      draft_generation: 'Draft generation',
      drafting_ocr: 'Drafting OCR',
      aadhaar_ocr: 'Aadhaar OCR',
      draftingEstimatedCredits: 'Estimated usage: {{credits}} credits, about {{input}} input tokens, {{output}} output tokens, and {{ocr}} OCR pages/images.',
      draftingCreditsAfterRun: 'This step used {{credits}} credits. {{remaining}} credits remain available now.',
      draftingEstimateUnavailable: 'Usage estimate will appear here once the drafting context is ready.',
      startAadhaarOcr: 'Start Aadhaar OCR',
      replaceAadhaarFile: 'Replace Aadhaar file',
      aadhaarAiGateTitle: 'Aadhaar OCR uses premium credits',
      aadhaarAiGateBody: 'Aadhaar intake uses OCR and mapping credits. Start a trial, subscribe to AI Plus, or top up credits before you continue with camera or file upload.',
      draftingPremiumGateTitle: 'This step needs premium credits',
      draftingPremiumGateBody: 'Source upload, OCR, and draft generation use premium credits. Start a trial, subscribe to AI Plus, or top up before you continue.',
      premiumActivating: 'Activating your premium plan.',
      goToDummyPayment: 'Continue to dummy payment',
      backToDashboard: 'Back to dashboard',
      subscribe: 'Subscribe',
      dummyPaymentTitle: 'Dummy payment',
      dummyPaymentSubtitle: 'This is a temporary placeholder flow until the real payment gateway is integrated.',
      dummyPaymentHeadline: 'Activate premium with a test payment',
      dummyPaymentBody: 'Proceed once to simulate a successful payment of Rs {{amount}} and activate premium on this advocate account.',
      dummyPaymentPlanLabel: 'AI Legal Drafting premium access',
      inrAmount: 'Rs {{amount}}',
      dummyPaymentMode: 'Test payment flow',
      dummyPaymentPurpose: 'Monthly premium subscription activation',
      dummyPaymentProcessing: 'Processing your premium activation.',
      proceedToPayment: 'Proceed to payment',
      back: 'Back',
      loadingWorkspace: 'Loading your workspace.',
      aiDraftingAssistant: 'AI Legal Drafting',
      aiDraftingSubtitle: 'Upload legal source material, review extracted text, and generate a private first draft for advocate review.',
      loadingDraftingWorkspace: 'Loading the drafting workspace.',
      draftingCasePrefillInstructions: 'Use the linked matter details as context while preparing this first draft for',
      draftingSetupSaved: 'Draft setup saved.',
      draftingTypedTextRequired: 'Add some notes or facts before saving typed text.',
      typedNotes: 'Typed notes',
      draftingSourceAdded: 'Drafting source added.',
      draftingExtractionComplete: 'Text extraction is ready for review.',
      draftingGenerationComplete: 'First draft generated successfully.',
      draftingDraftSaved: 'Draft changes saved.',
      draftingCopied: 'Draft copied to clipboard.',
      draftingExportReady: 'DOCX export is ready.',
      draftingPublishComplete: 'Draft published to case documents.',
      importantNotice: 'Important notice',
      aiDraftingDisclaimerTitle: 'AI-assisted first draft only',
      aiDraftingDisclaimerBody: 'Review every generated draft carefully before filing, sharing, or relying on it. OCR and AI may miss facts, formatting, or legal nuance.',
      draftSetup: 'Draft setup',
      configureDraft: 'Configure this draft',
      linkedMatter: 'Matter (optional)',
      standaloneDraft: 'Standalone draft',
      draftType: 'Draft type',
      customDraftType: 'Custom draft type',
      customDraftTypePlaceholder: 'For example, anticipatory bail reply',
      outputLanguage: 'Output language',
      draftInstructions: 'Advocate instructions',
      draftInstructionsPlaceholder: 'Mention tone, prayer, relief sought, facts to emphasise, or formatting needs.',
      saving: 'Saving',
      saveSetup: 'Save setup',
      startDraftWorkspace: 'Start drafting workspace',
      activeSession: 'Current session',
      sources: 'Sources',
      attachDraftingSources: 'Attach drafting sources',
      draftingDropzoneTitle: 'Upload PDFs, images, or notes for drafting',
      draftingDropzoneSubtitle: 'Text PDFs use direct extraction. Scanned PDFs and images use Google Cloud Vision OCR.',
      pasteFactsOrNotes: 'Paste facts or advocate notes',
      typedNotesPlaceholder: 'Paste chronology, facts, instructions, or prayer notes here.',
      addTypedNotes: 'Add typed notes',
      processing: 'Processing',
      processingDraftingRequest: 'Working on your drafting request.',
      draftingPreparing: 'Preparing your drafting workflow.',
      draftingProgressSession: 'Preparing drafting context',
      draftingProgressSessionDetail: 'Saving the selected client, case context, and advocate instructions.',
      draftingProgressUpload: 'Uploading source files',
      draftingProgressUploadDetail: 'Uploading {{count}} file(s) and attaching them to this workflow.',
      draftingProgressExtract: 'Extracting text',
      draftingProgressExtractDetail: 'Reading text and OCR content from {{count}} source file(s).',
      draftingProgressGenerate: 'Generating first draft',
      draftingProgressGenerateDetail: 'Sending structured context, source text, and instructions to AI.',
      draftingProgressValidate: 'Opening fact validation',
      draftingProgressValidateDetail: 'Preparing the final fact-check form before draft review.',
      draftingProgressFailed: 'Drafting needs attention',
      draftingProgressStepLabel: 'Step {{current}} of {{total}}',
      draftingProgressFilesLabel: '{{count}} file(s)',
      draftingProgressEstimatedTokensLabel: '~{{count}} estimated tokens',
      draftingValidationSaving: 'Saving reviewed facts and preparing the final draft.',
      draftingValidationComplete: 'Key facts reviewed. Opening final draft review.',
      draftingReviewFooterTitle: 'Advocate review note:',
      draftingReviewFooterPending: 'The following items may still need attention:',
      draftingReviewFooterClean: 'Key factual fields were reviewed once. Please still do a full legal review before use.',
      extractReviewText: 'Extract and review text',
      useAsSource: 'Use as drafting source',
      draftingNoExistingDocuments: 'No existing case documents are available for this matter yet.',
      review: 'Review',
      reviewExtractedText: 'Review extracted text',
      draftingNoSources: 'No sources added yet. Upload files, attach existing documents, or paste typed notes first.',
      untitledSource: 'Untitled source',
      removeSource: 'Remove source',
      reviewedTextPlaceholder: 'Review and correct the extracted text before generation.',
      generatedDraft: 'Generated draft',
      firstDraft: 'First draft',
      draftingNoOutput: 'Generate a draft after your source text is ready.',
      generatingDraft: 'Generating draft',
      generateDraft: 'Generate draft',
      saveDraft: 'Save draft',
      copyText: 'Copy text',
      exportDocx: 'Export DOCX',
      publishToCaseDocuments: 'Publish to case documents',
      openDraftingAssistant: 'Open drafting assistant',
      clientDetails: 'Client details',
      loadingClientDetails: 'Loading client details.',
      clientNotFound: 'This client could not be found.',
      clientDetailsSubtitle: 'Contact details, linked matters, and matter activity for this client.',
      clientCasesEmpty: 'No linked matters were found for this client yet.',
      lifecycleItemType: 'Lifecycle item type',
      generalStage: 'General stage',
      hearingStage: 'Hearing stage',
      scheduledDate: 'Scheduled date',
      stageNotes: 'Stage notes',
      stageNotesPlaceholder: 'Purpose, court note, adjournment note, or outcome summary.',
      nextHearingLabel: 'Next hearing:',
      hearingOn: 'Hearing on',
      hearingStages: 'hearing stages',
      copyrightLine: '© iAdvocate by SolidAI @ 2026 {{version}}. All rights reserved.',
    },
  },
  hi: {
    translation: {
      appName: 'iAdvocate',
      login: 'लॉगिन',
      email: 'ईमेल',
      password: 'पासवर्ड',
      submit: 'जारी रखें',
      dashboard: 'डैशबोर्ड',
      cases: 'केसेस',
      clients: 'क्लाइंट्स',
      hearings: 'हियरिंग्स',
      payments: 'पेमेंट्स',
      documents: 'डॉक्यूमेंट्स',
      chooseLanguage: 'अपनी भाषा चुनें',
      english: 'अंग्रेज़ी',
      hindi: 'हिंदी',
      next: 'आगे',
      start: 'शुरू करें',
      profileSetup: 'प्रोफ़ाइल सेटअप',
      myProfile: 'मेरी प्रोफ़ाइल',
      name: 'नाम',
      phone: 'फ़ोन',
      address: 'पता',
      profilePic: 'प्रोफ़ाइल फ़ोटो',
      save: 'सहेजें',
      inviteAdvocates: 'एडवोकेट आमंत्रित करें',
      generateLink: 'आमंत्रण लिंक बनाएं',
      home: 'होम',
      secureAccess: 'सुरक्षित प्रवेश',
      roleBasedAccess: 'भूमिका आधारित प्रवेश',
      firstTimeSetup: 'पहली बार सेटअप',
      createAccount: 'अपना खाता बनाएं',
      createOne: 'खाता बनाएं',
      signIn: 'साइन इन करें',
      continueWithGoogle: 'Google के साथ जारी रखें',
      needTestAccount: 'टेस्ट खाता चाहिए?',
      alreadyHaveAccount: 'पहले से खाता है?',
      selectLanguage: 'भाषा',
      continueLabel: 'जारी रखें',
      languageSubtitle: 'एडवोकेट्स के लिए केसेस, अपडेट्स, क्लाइंट लिंक्स और पेमेंट्स संभालने का एक सरल लीगल वर्कस्पेस।',
      loginSubtitle: 'साइन इन करें और अपने एडवोकेट या एडमिन वर्कस्पेस में जाएं।',
      signupSubtitle: 'एडवोकेट या एडमिन अकाउंट बनाएं। क्लाइंट्स केवल सुरक्षित केस लिंक से जुड़ेंगे।',
      profileSubtitle: 'अपनी प्रोफ़ाइल पूरी करें ताकि आपका लीगल वर्कस्पेस मोबाइल, टैबलेट और डेस्कटॉप पर तैयार रहे।',
      role: 'भूमिका',
      confirmPassword: 'पासवर्ड की पुष्टि करें',
      createAccountButton: 'खाता बनाएं',
      logout: 'लॉगआउट',
      recorded: 'दर्ज',
      tentative: 'अनुमानित',
      dateToBeUpdated: 'तारीख बाद में अपडेट होगी',
      timelineReached: 'समयरेखा पूरी हुई',
      practiceDashboard: 'प्रैक्टिस डैशबोर्ड',
      practiceDashboardSubtitle: 'आपके काम का सार, मामलों, क्लाइंट और सक्रिय फॉलो-अप तक तेज पहुंच के साथ।',
      todayAtAGlance: 'आज का सार',
      dashboardHeroTitle: 'सारी ज़रूरी अपडेट्स एक ही टैप दूर हैं।',
      dashboardHeroSubtitle:
        'केसेस या क्लाइंट्स खोलें और हियरिंग नोट्स, पेमेंट फॉलो-अप, डॉक्यूमेंट्स और क्लाइंट लिंक्स को उसी संदर्भ में संभालें।',
      activeMatters: 'ऐक्टिव केसेस',
      immediateFocus: 'तुरंत ध्यान',
      reminders: 'रिमाइंडर',
      noUrgentReminders: 'कोई तुरंत रिमाइंडर नहीं है। अगली सुनवाई की अवधि स्पष्ट है।',
      nextSevenDays: 'अगले सात दिन',
      upcomingHearings: 'अपकमिंग हियरिंग्स',
      noHearingsWeek: 'अगले 7 दिनों में कोई हियरिंग शेड्यूल नहीं है।',
      trackStatusClientMapping: 'स्थिति और क्लाइंट मैपिंग ट्रैक करें।',
      keepContactsAccessible: 'कोर्ट विज़िट के दौरान संपर्क विवरण सुलभ रखें।',
      clientLinks: 'क्लाइंट लिंक्स',
      shareSecureClientLinks: 'क्लाइंट्स के साथ सुरक्षित केस लिंक्स सीधे शेयर करें।',
      clientsSubtitle: 'मुख्य कॉन्टैक्ट डिटेल्स कुछ टैप में उपलब्ध रखें।',
      clientIntake: 'क्लाइंट इनटेक',
      addClient: 'क्लाइंट जोड़ें',
      clientFullName: 'क्लाइंट का पूरा नाम',
      mobileNumber: '10-अंकों का मोबाइल नंबर',
      optionalEmail: 'वैकल्पिक ईमेल पता',
      directory: 'डायरेक्टरी',
      clientsEmpty: 'आपकी क्लाइंट लिस्ट अभी खाली है। एक क्लाइंट जोड़कर शुरुआत करें।',
      noEmailAdded: 'कोई ईमेल नहीं जोड़ा गया',
      hearingsSubtitle: 'केस लाइफसाइकल में जुड़ी अपकमिंग हियरिंग्स को साफ़ तौर पर देखें।',
      schedule: 'शेड्यूल',
      addHearing: 'हियरिंग जोड़ें',
      caseId: 'केस आईडी',
      linkedCaseNumber: 'लिंक किया गया केस नंबर',
      date: 'तारीख',
      description: 'विवरण',
      purposeOfHearing: 'हियरिंग का पर्पज़',
      calendar: 'कैलेंडर',
      hearingsEmpty: 'अभी तक कोई हियरिंग स्टेज नहीं जोड़ी गई है। किसी केस की लाइफसाइकल से शुरू करें।',
      noDescriptionAdded: 'कोई विवरण नहीं जोड़ा गया',
      paymentsSubtitle: 'फीस जल्दी रिकॉर्ड करें और क्लाइंट फॉलो-अप के समय पेमेंट हिस्ट्री तुरंत देखें।',
      feeEntry: 'फीस एंट्री',
      addPayment: 'पेमेंट जोड़ें',
      amount: 'राशि',
      amountInInr: 'राशि INR में',
      paymentPurpose: 'यह भुगतान किस लिए था?',
      clientAction: 'क्लाइंट ऐक्शन',
      requestClientPayment: 'क्लाइंट से पेमेंट रिक्वेस्ट करें',
      recordReceivedPayment: 'मिला हुआ पेमेंट रिकॉर्ड करें',
      collections: 'संग्रह',
      entries: 'एंट्री',
      paymentsEmpty: 'अभी तक कोई पेमेंट रिकॉर्ड नहीं है। ट्रैकिंग शुरू करने के लिए नया पेमेंट जोड़ें।',
      paid: 'भुगतान हुआ',
      documentsSubtitle: 'बड़े टच टारगेट और क्विक एक्सेस लिंक्स के साथ केस फाइल्स अपलोड करें।',
      documentsUploadGuard: 'अपलोड करने से पहले केस आईडी और डॉक्यूमेंट टाइप भरें।',
      uploadPrep: 'अपलोड तैयारी',
      documentDetails: 'डॉक्यूमेंट डिटेल्स',
      type: 'प्रकार',
      documentTypePlaceholder: 'शपथपत्र, नोटिस, वकालतनामा...',
      documentsDropzoneTitle: 'अपलोड करने के लिए टैप करें या फाइल यहां खींचें',
      documentsDropzoneSubtitle: 'पीडीएफ, इमेजेज़ और नोट्स चुने गए केस से जोड़े जा सकते हैं।',
      library: 'लाइब्रेरी',
      files: 'फाइलें',
      documentsEmpty: 'अभी तक कोई डॉक्यूमेंट अपलोड नहीं है। केस आईडी जोड़ें, टाइप चुनें और फाइल अपलोड करें।',
      generalFile: 'जनरल फाइल',
      forLabel: 'के लिए',
      unassignedCase: 'असाइन नहीं किया गया केस',
      open: 'खोलें',
      adminDashboard: 'एडमिन डैशबोर्ड',
      adminDashboardSubtitle: 'खाता स्थिति, भूमिका वितरण और प्लेटफॉर्म जांच के लिए हल्का IT एडमिन दृश्य।',
      admins: 'एडमिन',
      advocates: 'एडवोकेट',
      operations: 'ऑपरेशन्स',
      systemAlerts: 'सिस्टम अलर्ट',
      platformSnapshot: 'प्लेटफॉर्म स्नैपशॉट',
      itAdminControls: 'IT एडमिन कंट्रोल',
      authentication: 'ऑथेंटिकेशन',
      authenticationSummary: 'टेस्टिंग के लिए ऐप फ्लो में ईमेल/पासवर्ड और Google साइन-इन सक्षम हैं।',
      active: 'सक्रिय',
      paymentsTracked: 'ट्रैक किए गए भुगतान',
      paymentsTrackedSummary: 'एडवोकेट और क्लाइंट व्यू में {{count}} भुगतान रिकॉर्ड उपलब्ध हैं।',
      adminDataIsolationSummary: 'एडमिन एक्सेस केवल एडमिन के अपने अलर्ट और ऑपरेशनल जांच तक सीमित है। एडवोकेट-क्लाइंट डेटा जानबूझकर अलग रखा गया है।',
      live: 'लाइव',
      clientAccessLinks: 'क्लाइंट एक्सेस लिंक',
      clientAccessLinksSubtitle:
        'WhatsApp, SMS या ईमेल पर क्लाइंट-सुरक्षित केस दृश्य साझा करें। लिंक केस बंद होने या आपके द्वारा अक्षम करने तक सक्रिय रहेगा।',
      shareableCaseAccess: 'साझा करने योग्य केस एक्सेस',
      links: 'लिंक',
      clientLinksEmpty: 'अभी तक कोई केस उपलब्ध नहीं है। पहले केस जोड़ें, फिर यहां आकर उसका क्लाइंट लिंक साझा करें।',
      shareOnWhatsApp: 'WhatsApp पर साझा करें',
      shareBySms: 'SMS द्वारा साझा करें',
      previewClientCaseView: 'क्लाइंट केस व्यू देखें',
      preferredLanguage: 'पसंदीदा भाषा',
      casesSubtitle: 'एडवोकेट और क्लाइंट दोनों व्यू के लिए स्पष्ट लाइफसायकल योजना के साथ मामले बनाएं, देखें और साझा करें।',
      newMatter: 'नया मामला',
      addCase: 'केस जोड़ें',
      closeAddCaseForm: 'केस फॉर्म बंद करें',
      openAddCaseForm: 'केस फॉर्म खोलें',
      caseNumber: 'केस नंबर',
      clientName: 'क्लाइंट नाम',
      clientEmail: 'क्लाइंट ईमेल',
      clientPhone: 'क्लाइंट फोन',
      caseSummary: 'केस सारांश',
      nextStep: 'अगला चरण',
      statusLabel: 'स्थिति',
      stepPreset: 'स्टेप प्रीसेट',
      tentativeMonth: 'अनुमानित महीना',
      lifecyclePlanning: 'लाइफसायकल योजना',
      stepTitle: 'स्टेप शीर्षक',
      addLifecycleStep: 'लाइफसायकल स्टेप जोड़ें',
      addCaseButton: 'केस जोड़ें',
      addMatterHint: 'योजनाबद्ध माइलस्टोन और क्लाइंट एक्सेस लिंक के साथ नया मामला बनाने के लिए प्लस आइकन दबाएं।',
      currentMatters: 'वर्तमान मामले',
      caseBoard: 'केस बोर्ड',
      noCasesYet: 'अभी तक कोई केस नहीं है। प्रगति ट्रैक करने के लिए अपना पहला मामला जोड़ें।',
      noNextStepYet: 'अभी तक कोई अगला चरण नहीं जोड़ा गया।',
      noLifecyclePlanned: 'कोई लाइफसायकल योजना नहीं है',
      milestonesComplete: 'माइलस्टोन पूरे',
      clientLinkLive: 'क्लाइंट लिंक सक्रिय',
      clientLinkPaused: 'क्लाइंट लिंक रुका हुआ',
      openCaseDetails: 'केस विवरण खोलें',
      caseDetails: 'केस विवरण',
      loadingMatterDetails: 'मामले का विवरण लोड हो रहा है।',
      caseNotFound: 'यह केस नहीं मिला।',
      caseDetailsSubtitle: 'मामले का विवरण, क्लाइंट एक्सेस, लाइफसायकल ट्रैकिंग और केस-लिंक्ड भुगतान एक ही जगह।',
      clientLabel: 'क्लाइंट',
      clientContactMissing: 'क्लाइंट संपर्क अभी नहीं जोड़ा गया है।',
      matterBrief: 'मामले का संक्षेप',
      summaryLabel: 'सारांश',
      noSummaryAdded: 'अभी तक कोई सारांश नहीं जोड़ा गया।',
      nextStepShort: 'अगला चरण',
      clientLinkLabel: 'क्लाइंट लिंक',
      clientLinkActive: 'केस बंद होने या मैन्युअल रोक तक सक्रिय।',
      clientLinkDisabled: 'वर्तमान में अक्षम।',
      lifecycle: 'लाइफसायकल',
      progressControl: 'प्रगति नियंत्रण',
      pauseClientAccess: 'क्लाइंट एक्सेस रोकें',
      enableClientAccess: 'क्लाइंट एक्सेस सक्षम करें',
      stepNumber: 'स्टेप {{count}}',
      inProgress: 'प्रगति पर',
      done: 'पूरा',
      requestOrRecordFees: 'फीस का अनुरोध या रिकॉर्ड करें',
      closePaymentForm: 'भुगतान फॉर्म बंद करें',
      openPaymentForm: 'भुगतान फॉर्म खोलें',
      stage: 'चरण',
      paymentMode: 'भुगतान मोड',
      requestFromClient: 'क्लाइंट से अनुरोध करें',
      recordReceived: 'प्राप्त भुगतान दर्ज करें',
      requestPayment: 'भुगतान का अनुरोध करें',
      savePayment: 'भुगतान सहेजें',
      feeFormHint: 'जब आपको भुगतान का अनुरोध करना हो या प्राप्त राशि दर्ज करनी हो, तब फीस फॉर्म खोलें।',
      caseFee: 'केस फीस',
      clientCaseAccess: 'क्लाइंट केस एक्सेस',
      clientCaseAccessSubtitle: 'आपके मामले से संबंधित प्रगति, भुगतान, दस्तावेज़ और अपडेट देखने के लिए आपके एडवोकेट द्वारा साझा किया गया।',
      loadingCaseAccess: 'केस एक्सेस लोड हो रहा है',
      openingClientView: 'इस केस लिंक के लिए क्लाइंट व्यू खोला जा रहा है।',
      linkNotFound: 'लिंक नहीं मिला',
      invalidClientLink: 'यह क्लाइंट एक्सेस लिंक अमान्य है या अब मौजूद नहीं है।',
      caseAccessClosed: 'केस एक्सेस बंद',
      caseAccessClosedSubtitle: 'यह लिंक अब सक्रिय नहीं है क्योंकि केस पूरा हो गया है या क्लाइंट एक्सेस अक्षम कर दिया गया है।',
      importantDetails: 'महत्वपूर्ण विवरण',
      court: 'कोर्ट',
      notAdded: 'नहीं जोड़ा गया',
      nextStepSoon: 'आपका एडवोकेट अगला चरण जल्द अपडेट करेगा।',
      progressTracker: 'प्रगति ट्रैकर',
      caseLifecycle: 'केस लाइफसायकल',
      completedRecordedByAdvocate: 'पूरा किया गया और आपके एडवोकेट द्वारा दर्ज किया गया।',
      currentlyActiveInCase: 'वर्तमान में आपके केस में सक्रिय है।',
      upcomingCaseJourney: 'केस यात्रा में आगे आने वाला।',
      fees: 'फीस',
      requestedSubmittedPayments: 'अनुरोधित और जमा किए गए भुगतान',
      amountPaid: 'भुगतान की गई राशि',
      paymentNote: 'भुगतान नोट',
      paymentNotePlaceholder: 'रेफरेंस, UPI नोट या चरण',
      submitPaymentUpdate: 'भुगतान अपडेट जमा करें',
      sharedFilesUploads: 'साझा की गई फाइलें और अपलोड',
      shared: 'साझा',
      tapToUploadCaseDoc: 'इस केस के लिए दस्तावेज़ या छवि अपलोड करने के लिए टैप करें',
      clientUploadHint: 'आपका एडवोकेट इस अपलोड को केस रिकॉर्ड में देख सकेगा।',
      comments: 'टिप्पणियाँ',
      updatesQuestions: 'अपडेट और प्रश्न',
      addMessageForAdvocate: 'अपने एडवोकेट के लिए संदेश जोड़ें',
      sendMessage: 'संदेश भेजें',
      aiDraftingAssistant: 'एआई लीगल ड्राफ्टिंग',
      aiDraftingSubtitle: 'कानूनी स्रोत सामग्री जोड़ें, निकाले गए पाठ की समीक्षा करें, और वकील समीक्षा के लिए निजी पहला ड्राफ्ट तैयार करें।',
      loadingDraftingWorkspace: 'ड्राफ्टिंग कार्यक्षेत्र लोड हो रहा है।',
      draftingCasePrefillInstructions: 'इस पहले ड्राफ्ट को तैयार करते समय लिंक किए गए मामले का संदर्भ उपयोग करें',
      draftingSetupSaved: 'ड्राफ्ट सेटअप सहेजा गया।',
      draftingTypedTextRequired: 'टाइप किया हुआ पाठ सहेजने से पहले कुछ नोट्स या तथ्य जोड़ें।',
      typedNotes: 'टाइप किए गए नोट्स',
      draftingSourceAdded: 'ड्राफ्टिंग स्रोत जोड़ दिया गया।',
      draftingExtractionComplete: 'पाठ निष्कर्षण समीक्षा के लिए तैयार है।',
      draftingGenerationComplete: 'पहला ड्राफ्ट सफलतापूर्वक तैयार हुआ।',
      draftingDraftSaved: 'ड्राफ्ट परिवर्तन सहेज दिए गए।',
      draftingCopied: 'ड्राफ्ट क्लिपबोर्ड पर कॉपी हो गया।',
      draftingExportReady: 'DOCX निर्यात तैयार है।',
      draftingPublishComplete: 'ड्राफ्ट केस दस्तावेज़ों में प्रकाशित कर दिया गया।',
      importantNotice: 'महत्वपूर्ण सूचना',
      aiDraftingDisclaimerTitle: 'यह केवल एआई-सहायित पहला ड्राफ्ट है',
      aiDraftingDisclaimerBody: 'किसी भी तैयार ड्राफ्ट को दाखिल करने, साझा करने या उपयोग करने से पहले ध्यान से समीक्षा करें। OCR और AI तथ्य, प्रारूप या कानूनी सूक्ष्मता छोड़ सकते हैं।',
      draftSetup: 'ड्राफ्ट सेटअप',
      configureDraft: 'यह ड्राफ्ट कॉन्फ़िगर करें',
      linkedMatter: 'लिंक किया गया मामला',
      standaloneDraft: 'स्वतंत्र ड्राफ्ट',
      draftType: 'ड्राफ्ट प्रकार',
      customDraftType: 'कस्टम ड्राफ्ट प्रकार',
      customDraftTypePlaceholder: 'उदाहरण: अग्रिम ज़मानत उत्तर',
      outputLanguage: 'आउटपुट भाषा',
      draftInstructions: 'वकील निर्देश',
      draftInstructionsPlaceholder: 'टोन, प्रार्थना, मांगी गई राहत, प्रमुख तथ्य, या प्रारूप आवश्यकताएँ लिखें।',
      saving: 'सहेजा जा रहा है',
      saveSetup: 'सेटअप सहेजें',
      startDraftWorkspace: 'ड्राफ्टिंग कार्यक्षेत्र शुरू करें',
      activeSession: 'वर्तमान सत्र',
      sources: 'स्रोत',
      attachDraftingSources: 'ड्राफ्टिंग स्रोत जोड़ें',
      draftingDropzoneTitle: 'ड्राफ्टिंग के लिए PDF, चित्र, या नोट्स अपलोड करें',
      draftingDropzoneSubtitle: 'टेक्स्ट PDF सीधे निकाले जाते हैं। स्कैन किए गए PDF और चित्र Google Cloud Vision OCR का उपयोग करते हैं।',
      pasteFactsOrNotes: 'तथ्य या वकील नोट्स पेस्ट करें',
      typedNotesPlaceholder: 'यहाँ घटनाक्रम, तथ्य, निर्देश, या प्रार्थना नोट्स पेस्ट करें।',
      addTypedNotes: 'टाइप किए गए नोट्स जोड़ें',
      processing: 'प्रोसेस हो रहा है',
      draftingPreparing: 'ड्राफ्टिंग वर्कफ़्लो तैयार किया जा रहा है।',
      draftingProgressSession: 'ड्राफ्टिंग संदर्भ तैयार हो रहा है',
      draftingProgressSessionDetail: 'चुने गए क्लाइंट, केस संदर्भ और एडवोकेट निर्देश सहेजे जा रहे हैं।',
      draftingProgressUpload: 'सोर्स फाइलें अपलोड हो रही हैं',
      draftingProgressUploadDetail: '{{count}} फाइलें अपलोड करके इस वर्कफ़्लो से जोड़ी जा रही हैं।',
      draftingProgressExtract: 'पाठ निकाला जा रहा है',
      draftingProgressExtractDetail: '{{count}} सोर्स फाइलों से टेक्स्ट और OCR सामग्री पढ़ी जा रही है।',
      draftingProgressGenerate: 'पहला ड्राफ्ट तैयार हो रहा है',
      draftingProgressGenerateDetail: 'संरचित संदर्भ, सोर्स टेक्स्ट और निर्देश एआई को भेजे जा रहे हैं।',
      draftingProgressValidate: 'फैक्ट वैलिडेशन खोला जा रहा है',
      draftingProgressValidateDetail: 'ड्राफ्ट रिव्यू से पहले अंतिम फैक्ट-चेक फ़ॉर्म तैयार किया जा रहा है।',
      draftingProgressFailed: 'ड्राफ्टिंग को ध्यान चाहिए',
      draftingProgressStepLabel: 'चरण {{current}} / {{total}}',
      draftingProgressFilesLabel: '{{count}} फाइलें',
      draftingProgressEstimatedTokensLabel: '~{{count}} अनुमानित टोकन्स',
      draftingValidationSaving: 'रिव्यू किए गए तथ्यों को सहेजा जा रहा है और अंतिम ड्राफ्ट तैयार किया जा रहा है।',
      draftingValidationComplete: 'महत्वपूर्ण तथ्य रिव्यू हो गए। अंतिम ड्राफ्ट रिव्यू खोला जा रहा है।',
      draftingReviewFooterTitle: 'एडवोकेट रिव्यू नोट:',
      draftingReviewFooterPending: 'निम्नलिखित बिंदुओं पर अभी भी ध्यान देना पड़ सकता है:',
      draftingReviewFooterClean: 'महत्वपूर्ण तथ्य एक बार रिव्यू किए जा चुके हैं। उपयोग से पहले पूरा कानूनी रिव्यू फिर भी करें।',
      extractReviewText: 'पाठ निकालें और समीक्षा करें',
      useAsSource: 'ड्राफ्टिंग स्रोत के रूप में उपयोग करें',
      draftingNoExistingDocuments: 'इस मामले के लिए अभी कोई मौजूदा दस्तावेज़ उपलब्ध नहीं हैं।',
      review: 'समीक्षा',
      reviewExtractedText: 'निकाले गए पाठ की समीक्षा करें',
      draftingNoSources: 'अभी तक कोई स्रोत नहीं जोड़ा गया है। पहले फाइल अपलोड करें, मौजूदा दस्तावेज़ जोड़ें, या नोट्स पेस्ट करें।',
      untitledSource: 'बिना शीर्षक का स्रोत',
      removeSource: 'स्रोत हटाएँ',
      reviewedTextPlaceholder: 'जेनरेशन से पहले निकाले गए पाठ की समीक्षा करें और उसे ठीक करें।',
      generatedDraft: 'तैयार ड्राफ्ट',
      firstDraft: 'पहला ड्राफ्ट',
      draftingNoOutput: 'स्रोत पाठ तैयार होने के बाद ड्राफ्ट जनरेट करें।',
      generatingDraft: 'ड्राफ्ट तैयार हो रहा है',
      generateDraft: 'ड्राफ्ट जनरेट करें',
      saveDraft: 'ड्राफ्ट सहेजें',
      copyText: 'पाठ कॉपी करें',
      exportDocx: 'DOCX निर्यात करें',
      publishToCaseDocuments: 'केस दस्तावेज़ों में प्रकाशित करें',
      openDraftingAssistant: 'ड्राफ्टिंग असिस्टेंट खोलें',
      clientDetails: 'क्लाइंट विवरण',
      loadingClientDetails: 'क्लाइंट विवरण लोड हो रहा है।',
      clientNotFound: 'यह क्लाइंट नहीं मिला।',
      clientDetailsSubtitle: 'इस क्लाइंट के लिए संपर्क विवरण, जुड़े हुए मामले और गतिविधि।',
      clientCasesEmpty: 'इस क्लाइंट के लिए अभी कोई जुड़ा हुआ मामला नहीं मिला।',
      lifecycleItemType: 'लाइफसाइकल आइटम प्रकार',
      generalStage: 'सामान्य चरण',
      hearingStage: 'सुनवाई चरण',
      scheduledDate: 'निर्धारित तारीख',
      stageNotes: 'चरण नोट्स',
      stageNotesPlaceholder: 'उद्देश्य, कोर्ट नोट, स्थगन नोट, या परिणाम सारांश लिखें।',
      nextHearingLabel: 'अगली सुनवाई:',
      hearingOn: 'सुनवाई दिनांक',
      hearingStages: 'सुनवाई चरण',
      openAddClientForm: 'क्लाइंट फॉर्म खोलें',
      closeAddClientForm: 'क्लाइंट फॉर्म बंद करें',
      addClientHint: 'नया क्लाइंट प्रोफ़ाइल जोड़ने के लिए क्लाइंट फॉर्म खोलें।',
      closeAddStageForm: 'लाइफसाइकल स्टेज फॉर्म बंद करें',
      lifecycleFormHint: 'नई स्टेज जोड़नी हो तभी लाइफसाइकल फॉर्म खोलें।',
      caseNotes: 'केस नोट्स',
      caseNotesEmpty: 'अभी तक कोई केस नोट नहीं है। क्लाइंट मैसेज और एडवोकेट नोट्स यहां दिखेंगे।',
      openCaseNotesForm: 'केस नोट्स फॉर्म खोलें',
      closeCaseNotesForm: 'केस नोट्स फॉर्म बंद करें',
      addCaseNote: 'केस नोट जोड़ें',
      addCaseNotePlaceholder: 'क्लाइंट के लिए जवाब या कोई इंटरनल नोट जोड़ें।',
      saveCaseNote: 'केस नोट सहेजें',
      caseDocuments: 'केस डॉक्यूमेंट्स',
      caseDocumentsEmpty: 'इस केस के लिए अभी कोई केस डॉक्यूमेंट उपलब्ध नहीं है।',
      caseDocumentsHint: 'पब्लिश किए गए ड्राफ्ट और एडवोकेट द्वारा अपलोड की गई फाइलें यहां दिखेंगी।',
      expandCaseDocuments: 'केस डॉक्यूमेंट्स खोलें',
      collapseCaseDocuments: 'केस डॉक्यूमेंट्स बंद करें',
      editInDrafting: 'ड्राफ्टिंग में एडिट करें',
      clientSharedDocuments: 'क्लाइंट शेयर किए डॉक्यूमेंट्स',
      clientDocumentsEmpty: 'इस मैटर के लिए अभी तक कोई क्लाइंट डॉक्यूमेंट शेयर नहीं हुआ है।',
      clientDocumentsHint: 'क्लाइंट द्वारा अपलोड की गई फाइल्स देखने के लिए यह सेक्शन खोलें।',
      expandClientDocuments: 'क्लाइंट डॉक्यूमेंट्स सेक्शन खोलें',
      collapseClientDocuments: 'क्लाइंट डॉक्यूमेंट्स सेक्शन बंद करें',
      caseNotesHint: 'ज़रूरत होने पर नोट्स हिस्ट्री खोलें या नया नोट जोड़ें।',
      openCaseNotesHistory: 'केस नोट्स हिस्ट्री खोलें',
      closeCaseNotesHistory: 'केस नोट्स हिस्ट्री बंद करें',
      openPaymentHistory: 'पेमेंट हिस्ट्री खोलें',
      closePaymentHistory: 'पेमेंट हिस्ट्री बंद करें',
      previewModeNotice: 'प्रिव्यू मोड चालू है। क्लाइंट एक्शन्स यहां दिखते हैं, लेकिन एडवोकेट रिव्यू के लिए बंद हैं।',
      previewModeUploadHint: 'प्रिव्यू मोड में अपलोड बंद है।',
      uploadPhoto: 'फ़ोटो अपलोड करें',
      changePhoto: 'फ़ोटो बदलें',
      installAppEyebrow: 'Welcome',
      installAppTitle: 'Opening your workspace',
      installAppSubtitle: 'One moment while iAdvocate prepares your legal workspace.',
      installPromptReadyTitle: 'Add iAdvocate to your phone',
      installPromptReadyBody: 'Your browser is ready to add iAdvocate now. Confirm once and it will open from your home screen next time.',
      installPromptReadyStep: 'नीचे बटन दबाएँ और डिवाइस पूछे तो पुष्टि करें।',
      installPromptButton: 'iAdvocate जोड़ें',
      installLater: 'Not now',
      installContinueBrowser: 'Continue in browser',
      installMobileNudgeTitle: 'Use iAdvocate like an app',
      installMobileNudgeBody: 'For the best mobile experience, add iAdvocate to your home screen. It opens faster and feels cleaner for daily case work.',
      installManualHint: '',
      installSharePrompt: 'Share मेनू से iAdvocate को होम स्क्रीन पर जोड़ें।',
      installAndroidChromeTitle: 'इसे Android के Chrome में खोलें',
      installAndroidChromeBody: 'यह ब्राउज़र होम स्क्रीन वाला प्रॉम्प्ट नहीं दिखा रहा है।',
      installAndroidChromeStepOne: 'इस लिंक को कॉपी करें।',
      installAndroidChromeStepTwo: 'इसे अपने Android फ़ोन के Chrome में खोलें और वहीं आगे बढ़ें।',
      installAndroidManualTitle: 'Chrome मेनू का उपयोग करें',
      installAndroidManualBody: 'इस बार Chrome ने प्रॉम्प्ट नहीं दिखाया, लेकिन iAdvocate को जल्दी से जोड़ा जा सकता है।',
      installAndroidManualStepOne: 'Chrome का तीन-बिंदु मेनू खोलें।',
      installAndroidManualStepTwo: 'Add to Home screen या Install app चुनें।',
      installIosSafariTitle: 'इसे Safari में खोलें',
      installIosSafariBody: 'iPhone और iPad पर होम स्क्रीन वाला विकल्प केवल Safari में मिलता है।',
      installIosSafariStepOne: 'इस लिंक को कॉपी करें।',
      installIosSafariStepTwo: 'इसे Safari में खोलें और फिर वहीं से आगे बढ़ें।',
      installIosShareTitle: 'Share मेनू का उपयोग करें',
      installIosShareBody: 'Safari के Share शीट से iAdvocate को होम स्क्रीन पर जोड़ा जा सकता है।',
      installIosShareStepOne: 'Share मेनू खोलें।',
      installIosShareStepTwo: 'Add to Home Screen चुनें।',
      installIosShareButton: 'Share मेनू खोलें',
      installDesktopTitle: 'ब्राउज़र मेनू से जोड़ें',
      installDesktopBody: 'Desktop पर Chrome या Edge, iAdvocate को ऐप की तरह जोड़ सकते हैं।',
      installDesktopStepOne: 'ब्राउज़र मेनू या address bar का install आइकन खोलें।',
      installDesktopStepTwo: 'Install iAdvocate या Create shortcut चुनें।',
      installDesktopBrowserTitle: 'Chrome या Edge का उपयोग करें',
      installDesktopBrowserBody: 'यह ब्राउज़र iAdvocate के लिए install controls नहीं दिखा रहा है।',
      installDesktopBrowserStepOne: 'इस लिंक को कॉपी करें।',
      installDesktopBrowserStepTwo: 'इसे Chrome या Edge में खोलें और वहीं से आगे बढ़ें।',
      copyLinkButton: 'लिंक कॉपी करें',
      installLinkCopied: 'लिंक कॉपी हो गया',
      continueInBrowser: 'ब्राउज़र में जारी रखें',
      preferredLocale: 'hi-IN',
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('selectedLanguage') || 'en',
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'selectedLanguage',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
